import styled from "styled-components";

const InvalidCoin = styled.caption`
  && {
    font-family: inherit;
    font-size: 1.2rem;
    font-weight: 800;
    text-align: left;
    padding: 10px 5px;
    color: red;
  }
`;

export default InvalidCoin;
